export default {
	"2db9cae3de1545e51ce292dd1c28ce54": "自主訂閲商品詳情頁",
	"e2226b1a4170f9c1303104b265be3494": "自自主訂閲商品詳情頁_購買按鈕",
	"0bc2692358647d0447374ab7243fea7e": "選中的支付方式名稱"
}
